import React from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import {
  Popover,
  Button,
  ListItemText,
  ListItem,
  List
} from '@material-ui/core'
import InputIcon from '@material-ui/icons/Input'
import ProfileIcon from '@material-ui/icons/PermIdentity'
import { useTranslation } from 'react-i18next'

// Definizione degli stili per il componente
const useStyles = makeStyles((theme) => ({
  root: {
    width: 240,
    maxWidth: 'calc(100vw - 16px)',
    boxSizing: 'border-box',
    padding: theme.spacing(0.75),
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #e2e7eb',
    borderRadius: 10,
    boxShadow: '0 8px 24px rgba(31, 48, 61, 0.10)',
    overflow: 'hidden'
  },
  listItem: {
    minHeight: 40,
    padding: theme.spacing(0, 1.25),
    borderRadius: 7,
    color: '#33444f',
    fontSize: 14,
    fontWeight: 600,
    justifyContent: 'flex-start',
    textAlign: 'left',
    textTransform: 'none',
    transition: theme.transitions.create(['background-color', 'color'], {
      duration: theme.transitions.duration.shortest
    }),
    '&:hover': {
      backgroundColor: '#f6f8f9'
    },
    '&.Mui-focusVisible, &:focus-visible': {
      backgroundColor: '#f6f8f9',
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: -2
    },
    '& $itemIcon': {
      color: '#607987'
    },
    '& $itemText': {
      margin: 0
    },
    '& $itemText span': {
      color: 'inherit',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      lineHeight: 1.3
    }
  },
  itemIcon: {
    width: 18,
    height: 18,
    marginRight: theme.spacing(1.25),
    flexShrink: 0
  },
  itemText: {},
  logoutItem: {
    '&:hover': {
      backgroundColor: '#fff5f6',
      color: theme.palette.primary.main
    }
  }
}))

/* Componente responsabile della visualizzazione del menu sulla TopBar */
function ProfilePopover ({ anchorEl, handleLogout, ...rest }) {
  const classes = useStyles()
  const history = useHistory()

  const { t } = useTranslation('profilePopover')

  // funzione che rimanda alla pagina del profilo utente
  const goToProfile = (url = '/profile') => {
    history.push(url)
    rest.onClose()
  }

  // Il Paper concentra dimensioni e offset senza alterare l'ancoraggio della topbar.
  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      PaperProps={{ className: classes.root }}
    >
      <List disablePadding>
        <ListItem
          className={classes.listItem}
          component={Button}
          color='inherit'
          onClick={() => goToProfile('/profile')}
        >
          <ProfileIcon aria-hidden='true' className={classes.itemIcon} />
          <ListItemText
            className={classes.itemText}
            primary={t('profileTitle')}
          />
        </ListItem>
        <ListItem
          className={`${classes.listItem} ${classes.logoutItem}`}
          component={Button}
          color='inherit'
          onClick={handleLogout}
        >
          <InputIcon aria-hidden='true' className={classes.itemIcon} />
          <ListItemText
            className={classes.itemText}
            primary={t('exitTitle')}
          />
        </ListItem>
      </List>
    </Popover>
  )
}

// Definizione delle proprietà accettate dal componente
ProfilePopover.propTypes = {
  anchorEl: PropTypes.any,
  handleLogout: PropTypes.func.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
}

export default ProfilePopover
